<div class="created-by">
  <figure class="created-by__avatar me-2 mb-0">
    <img [src]="avatar | resize : sizes : sizes" *ngIf="avatar" />
    <fstr-icon *ngIf="!avatar" [anchor]="'icon-' + firstletter"></fstr-icon>
  </figure>
  <span class="created-by__author" *ngIf="showName">{{ name }}</span>
</div>
